module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-icon",
    on: {
      "click": _vm.goToCart
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "21",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "20",
      "cy": "21",
      "r": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
    }
  })]), _vm._v(" "), (_vm.cartItemCount > 0) ? _c('span', {
    staticClass: "cart-badge"
  }, [_vm._v(_vm._s(_vm.cartItemCount))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4148bc56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartIcon.vue
// module id = 283
// module chunks = 1